export const getCommonApiUrl = (env) => {
    switch (env) {
        case 'ui-test':
            return 'http://localhost.telia.ee:3000/api';
        case 'local':
        case 'dev':
        case 'dev2':
            return 'https://www-dev.telia.ee/common/api';
        case 'test':
            return 'https://www-test.telia.ee/common/api';
        case 'live':
        default:
            return 'https://www.telia.ee/common/api';
    }
};
//# sourceMappingURL=UrlUtil.js.map